export class WorkflowsRightsServicesForm {
  serviceIds: number[];
}
